import React from "react";
import {
  AutoTextarea,
  getFieldStyle,
  getLabelStyle,
  SectionCard,
} from "../patientChartShared";

export default function MedicalSection({
  selectedEncounterId,
  medicalForm = {},
  setMedicalField,
  expandedSections,
  toggleSection,
  sectionRef,
  activeSection,
  readOnlyMode = false,
  errorCount = 0,
}) {
  return (
    <SectionCard
      title="Medical Section"
      sectionKey="medical"
      expandedSections={expandedSections}
      toggleSection={toggleSection}
      sectionRef={sectionRef}
      activeSection={activeSection}
      errorCount={errorCount}
    >
      {!selectedEncounterId ? (
        <div style={{ color: "#64748b" }}>
          Create or select an encounter first.
        </div>
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          <label style={getLabelStyle(medicalForm.hpiComplaint, true)}>
            HPI / Complaint
            <AutoTextarea
              value={medicalForm.hpiComplaint || ""}
              onChange={(e) => setMedicalField("hpiComplaint", e.target.value)}
              style={{
                ...getFieldStyle(medicalForm.hpiComplaint, true),
                minHeight: 88,
              }}
              disabled={readOnlyMode}
            />
          </label>

          <label style={getLabelStyle(medicalForm.assessment, true)}>
            Assessment
            <AutoTextarea
              value={medicalForm.assessment || ""}
              onChange={(e) => setMedicalField("assessment", e.target.value)}
              style={{
                ...getFieldStyle(medicalForm.assessment, true),
                minHeight: 88,
              }}
              disabled={readOnlyMode}
            />
          </label>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 8,
            }}
          >
            <label style={getLabelStyle(medicalForm.disposition, true)}>
              Disposition
              <select
                style={getFieldStyle(medicalForm.disposition, true)}
                value={medicalForm.disposition || ""}
                onChange={(e) => setMedicalField("disposition", e.target.value)}
                disabled={readOnlyMode}
              >
                <option value="">Select</option>
                <option value="dismissed">Dismissed</option>
                <option value="referredToPhysician">Referred to Physician</option>
                <option value="sentToHospital">Sent to Hospital</option>
                <option value="personalCar">Personal Car</option>
                <option value="rescueUnit">Rescue Unit</option>
                <option value="declinedTreatment">Declined Treatment</option>
              </select>
            </label>
          </div>

          <label style={getLabelStyle(medicalForm.planTreatmentDisposition, true)}>
            Plan / Treatment / Disposition
            <AutoTextarea
              value={medicalForm.planTreatmentDisposition || ""}
              onChange={(e) =>
                setMedicalField("planTreatmentDisposition", e.target.value)
              }
              style={{
                ...getFieldStyle(medicalForm.planTreatmentDisposition, true),
                minHeight: 96,
              }}
              disabled={readOnlyMode}
            />
          </label>
        </div>
      )}
    </SectionCard>
  );
}